var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineVolumeCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DBBD40BA-E58B-4FD7-B827-DD0C40ABE311") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Video,-Audio,-Image",
    transform: "translate(-364.000000, -188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "volume-cross",
    transform: "translate(364.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0200005,19.7601051 L7.0999999,17.9301062 C6.8999999,17.8101062 6.67000006,17.7401056 6.44000006,17.7401056 L5,17.7401056 C2.57999992,17.7401056 1.25,16.4101057 1.25,13.9901056 L1.25,9.99010515 C1.25,7.57010508 2.57999992,6.24010539 5,6.24010539 L6.42999983,6.24010539 C6.65999983,6.24010539 6.89000015,6.17010581 7.09000015,6.05010581 L10.0100002,4.22010529 C11.4700003,3.31010526 12.8900002,3.14010552 14.0100002,3.76010552 C15.1300002,4.38010553 15.7399998,5.67010546 15.7399998,7.40010548 L15.7399998,16.5701056 C15.7399998,18.2901056 15.1200002,19.590104 14.0100002,20.210104 C13.5700002,20.470104 13.0700002,20.5901051 12.5500002,20.5901051 C11.7600002,20.5901051 10.8900005,20.3101051 10.0200005,19.7601051 Z M2.75,10.0001054 L2.75,14.0001059 C2.75,15.5801059 3.41999996,16.2501059 5,16.2501059 L6.42999983,16.2501059 C6.94999981,16.2501059 7.44999987,16.3901059 7.88999987,16.6701059 L10.8100004,18.5001059 C11.7800004,19.1001059 12.6799999,19.2601059 13.29,18.9201059 C13.9,18.5801059 14.25,17.7301062 14.25,16.6001062 L14.25,7.41010523 C14.25,6.27010524 13.9,5.42010567 13.29,5.09010565 C12.6799999,4.75010565 11.7700004,4.90010583 10.8100004,5.51010585 L7.88000011,7.33010554 C7.45000011,7.61010554 6.93999982,7.75010538 6.42999983,7.75010538 L5,7.75010538 C3.41999996,7.75010538 2.75,8.42010534 2.75,10.0001054 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.470468,14.4899411 L17.5104688,10.5299408 C17.2204688,10.2399409 17.2204688,9.7599414 17.5104688,9.46994141 C17.8004687,9.17994142 18.2804682,9.17994142 18.5704682,9.46994141 L22.5304694,13.4299417 C22.8204694,13.7199416 22.8204694,14.1999411 22.5304694,14.4899411 C22.3804694,14.6299411 22.1904687,14.7099414 22.0004687,14.7099414 C21.8104687,14.7099414 21.6204681,14.6399411 21.470468,14.4899411 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4694531,14.5299802 C17.1794531,14.2399802 17.1794531,13.7599807 17.4694531,13.4699807 L21.4294543,9.50998047 C21.7194543,9.21998048 22.1994538,9.21998048 22.4894538,9.50998047 C22.7794538,9.79998046 22.7794538,10.2799799 22.4894538,10.5699799 L18.5294545,14.5299802 C18.3794545,14.6799802 18.1894538,14.7499804 17.9994538,14.7499804 C17.8094538,14.7499804 17.6194531,14.6799802 17.4694531,14.5299802 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineVolumeCross);
export default __webpack_public_path__ + "static/media/vuesax-outline-volume-cross.060bde00eed895885cbac00dd7d2d155.svg";
export { ForwardRef as ReactComponent };